import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import ResponsiveHeader from '../components/ResponsiveHeader';
import Footer from '../components/Footer';

const StripeCancelPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const getReturnPath = () => {
    if (type === 'shop') {
      return '/checkout';
    }
    return '/trainer/dashboard';
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <ResponsiveHeader />
      <div className="container max-w-lg mx-auto px-4 py-16">
        <Card className="text-center">
          <CardContent className="p-8">
            <div className="w-20 h-20 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-12 h-12 text-yellow-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Payment Cancelled
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              You cancelled the payment. No charges were made to your account.
            </p>
            <div className="space-y-3">
              <Button 
                onClick={() => navigate(getReturnPath())}
                className="w-full bg-purple-600 hover:bg-purple-700"
              >
                Try Again
              </Button>
              <Button 
                variant="outline"
                onClick={() => navigate('/')}
                className="w-full"
              >
                Back to Home
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
};

export default StripeCancelPage;
